import { FC } from 'react';
import styled from 'styled-components';

import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

type EditButtonsProps = {
  onSave: () => void;
  onCancel: () => void;
  disabled?: boolean;
};

export const EditButtons: FC<EditButtonsProps> = ({ onSave, onCancel, disabled }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'editTask' });

  return (
    <ButtonsWrapper>
      <Button size="middle" type="default" onClick={onCancel}>
        {t('cancel')}
      </Button>
      <Button size="middle" onClick={onSave} disabled={disabled}>
        {t('save')}
      </Button>
    </ButtonsWrapper>
  );
};

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
